<template>
  <main class="main-content" id="main-content">
    <div class="container" v-if="loaded">
      <section class="section">
        <page-header>
          <template v-slot:pageTitle>
            {{ $t("main") }}
          </template>
        </page-header>
        <div class="section__body">
          <tariff-block v-for="contract in contractObj" :contract="contract" :key="contract.idContract"></tariff-block>
          <tariff-block v-if="!contractObj" isDisabled></tariff-block>
        </div> 
      </section>
    </div>
    
  </main>
</template>
<script>
import PageHeader from "@/components/PageHeader";
import TariffBlock from "@/components/TariffBlock";
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    PageHeader,
    TariffBlock
  },
  data() {
    return {
      preloader: document.querySelector('.preloader'),
      loaded: false,
    }
  },
  computed: {
    ...mapGetters({
      personalData: 'personaldata/personalData',
      contractObj: 'personaldata/contractObject',
    }),
  },
  methods: { 
    ...mapActions({
      getPersonalData: 'personaldata/getPersonalData',
    }),

    showPreloader() {
      this.preloader.classList.remove('d-none')
    },
    hidePreloader() {
      this.preloader.classList.add('d-none');
    },
    isEmpty(obj) {
      for (let key in obj) {
        return false;
      }
      return true;
    }
  },
  created() {
    if(this.isEmpty(this.personalData)){
      this.showPreloader()
      this.getPersonalData().then(res => {
        if (res === 200) {
          this.hidePreloader()
          this.loaded = true
        } else if (res === 404) {
          this.$router.push({name: '404'})
          this.hidePreloader()
        }
      });
    }else{
      this.loaded = true
    }
  }
}
</script>
<style scoped>
.main-content{
  position: relative;
}
.confirm__error {
  opacity: 1;
  visibility: inherit;
}
.link{
  margin-top: 5px;
}
.modal_show {
  display: block;
  opacity: 1;
  background: rgba(255, 255, 255, .5);
}
.is_disabled {
  background-color: #ddd;
  color: #a7a7a7;
  border-color: #ddd;
}
.box__icon_disabled, .box__icon_disabled::before, .disabled .tariff__icon, .disabled .tariff::before {
  background-color: #d4d4d4;
}
.disabled__title{
  color: #8f8f8f;
}
.disabled .btn_grey{
  background-color: #8f8f8f;
}
.btn_grey_b{
  border-color: #8f8f8f;
  color: #8f8f8f;
}
</style>